import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ProgressEventService {

    downloadProgress: Subject<any> = new Subject();
    uploadProgress: Subject<any> = new Subject();
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/http/progress-event.service.ts